import { Grid } from '@mui/material';
import { MotionText } from '@shared/atoms';
import { LearningArticleCard } from '@shared/molecules';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './index.module.scss';

interface SectionProps {
  posts: { id: number; innerImageUrl: string; title: string }[];
  loadingPosts: boolean;
}

export const LearningSection: React.FC<SectionProps> = ({ posts, loadingPosts }) => {
  const history = useHistory();

  return (
    <section className={styles.journeySection} aria-labelledby="journey-heading">
      <div className={styles.blogPostSection}>
        <MotionText
          id="recommended-heading"
          className={styles.sectionTitle}
          as="h4"
          text="Recommended learning for you"
        />
        <Grid container spacing={4} className={styles.learningItemsContainer}>
          {posts &&
            posts.length > 0 &&
            posts.map((item, index: number) => (
              <Grid item xs={12} md={3} key={index}>
                <LearningArticleCard
                  data={item}
                  loading={loadingPosts}
                  sectionType={item.id === -999 ? 'allLearnings' : 'posts'}
                  navigateTo="oldPosts"
                />
              </Grid>
            ))}
        </Grid>

        {posts?.length === 0 && !loadingPosts && <p>No posts</p>}
      </div>
    </section>
  );
};
